import ISection from "./ISection";
import CheckManagerFields from "../../Manager/CheckManagerFields";

export default class BirthdaySection implements ISection {
  private readonly _birthday: JQuery<HTMLSelectElement>;
  private readonly legalAge: number = 18;

  constructor() {
    this._birthday = $("select[name*='form[birthDay]']");
    this.legalAge = +$(".legal-age").text();

    this._birthday.on("keyup keypress blur change", () => {
      this.onChange;
      if (this.isFormatValid) {
        this.CheckValidity();
      }
    });
  }

  public static get isPresent(): boolean {
    return $("select[name*='form[birthDay]']").length > 0;
  }

  private _onChange: () => void;

  public get onChange(): () => void {
    return this._onChange;
  }

  public set onChange(callback: () => void) {
    this._onChange = callback;
  }

  public get isValid(): boolean {
    //If the birthday field isn't present, we don't need to validate it
    if (this._birthday.length === 0) {
      return true;
    }

    return this.age >= this.legalAge;
  }

  private get year(): number {
    return +this._birthday.filter("[name*='[year]']").val().toString();
  }

  private get month(): number {
    return +this._birthday.filter("[name*='[month]']").val().toString();
  }

  private get day(): number {
    return +this._birthday.filter("[name*='[day]']").val().toString();
  }

  private get age() {
    if (!this.isFormatValid) {
      return 0;
    }
    const selectedDate = new Date(this.year, this.month - 1, this.day);

    const today = new Date();
    let age = today.getFullYear() - selectedDate.getFullYear();
    const monthDiff = today.getMonth() + 1 - this.month;
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && selectedDate.getDate() < today.getDate())
    ) {
      age--;
    }
    return age;
  }

  private get isFormatValid(): boolean {
    return this.year > 0 && this.month > 0 && this.day > 0;
  }

  public CheckValidity(): void {
    this.toggleEmptyDateError(this.isFormatValid);
    this.toggleIsMinorError(!this.isValid);
  }

  private toggleIsMinorError(isMinor: boolean): void {
    CheckManagerFields.DisplayError(
      $(this._birthday[0]).parent(),
      isMinor ? $(".wrong-date-message").text() : "",
    );
  }

  private toggleEmptyDateError(isMinor: boolean): void {
    CheckManagerFields.DisplayError(
      $(this._birthday[0]).parent(),
      !isMinor ? $(".empty-date-message").text() : "",
    );
  }
}
